import React from 'react';
import clsx from 'clsx';

import { ValidationErrors } from '@edx/hooks/use-validation-errors';
import { Avatar } from '@edx/components/avatar';
import { Button } from '@edx/components/button';
import { Textarea } from '@edx/components/form';

type Props = {
  author: {
    firstName: string;
    lastName: string;
    avatarUrl?: string | null;
  };
  buttonText: string;
  onSubmit: (comment: { body: string }) => void;
  validationErrors: ValidationErrors;
  showAvatar?: boolean;
};

export const AddCommentForm: React.FC<Props> = ({
  author,
  buttonText,
  onSubmit,
  validationErrors,
  showAvatar = true,
}) => {
  const [body, setBody] = React.useState('');
  const [isTextareaExpanded, setIsTextareaExpanded] = React.useState(false);
  const fullName = `${author.firstName} ${author.lastName}`;

  const handleInput = (setter: React.Dispatch<React.SetStateAction<string>>) => (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement | HTMLSelectElement>
  ): void => setter(event.target.value);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    onSubmit({ body });
    setBody('');
    setIsTextareaExpanded(false);
  };

  return (
    <form className="w-full flex space-x-2 p-2 bg-gray-300" onSubmit={handleSubmit}>
      {showAvatar && <Avatar name={fullName} src={author.avatarUrl} className="w-12 h-12" />}

      <div className="w-full flex flex-col">
        <Textarea
          placeholder="Añade una respuesta pública"
          variant="light"
          onChange={handleInput(setBody)}
          value={body}
          rows={1}
          cols={30}
          className={clsx('w-full', { 'min-h-128px transition': isTextareaExpanded })}
          error={validationErrors.body}
          onClick={(): void => setIsTextareaExpanded(true)}
        />

        <div className="mt-1">
          <Button variant="primary" size="small" textVariant="medium" type="submit" disabled={body.length === 0}>
            {buttonText}
          </Button>
        </div>
      </div>
    </form>
  );
};
